import { AbstractControl, FormGroup, FormControlName, FormControl } from '@angular/forms';

export class DatesValidator {

    static validDayInMonth(group:FormGroup) : any {
        let d : number = 0;
        let m : number = 0;
        let y : number = 0;

        d = group.controls.birthDateDay.value;
        m = group.controls.birthDateMonth.value;
        y = group.controls.birthDateYear.value;
       
        return (d > DatesValidator.getDaysInMonth(m,y)) ? { diaIncorrecto: true } : null;
    }

    static getDaysInMonth(month:number, year: number):number{

        return new Date(year,month,0).getDate();
    }    
}